//@styles
require('./contractDropdownAccount.scss');
// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { FormattedText } = require('core/i18n').i18n;
// @ utilities
const {
    filterValidAccounts,
    isUpgradeableToPayrollAccount
} = require('utilities/currentAccountsHelper');
const { recordLink } = require("utilities/tagging");
const { getLastNChars } = require('utilities/stringHelper');
const { findElementbyId } = require('routes/contractsView/utilities/contractStateHelper');
const formValidationHelper = require('routes/contractsView/utilities/formValidationHelper');
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');
// @ constants
const { EURO_TEXT, SAVINGS_ACCOUNT_TYPE} = require('constants/index');
const { ACCOUNT_CHOICE_ACTION_EVENT, OPEN_ACTION_EVENT, SELECTION_ACTION_EVENT } = require('constants/tagging');
// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKMessage } = require('commonsComponents/OKMessage');
// @ Local components
const ContractsAccountInterveners = require('../contractsAccountInterveners/contractsAccountInterveners');
const JuniorInterveners = require('../juniorInterveners/juniorInterveners');

class ContractDropdownAccount extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            accountsIndexes: []
        };
        this.handleFromAccountChange = this.handleFromAccountChange.bind(this);
        // this.onHandleForeignTaxReceiver = this.onHandleForeignTaxReceiver.bind(this);
    }

    static getDerivedStateFromProps(props) {
        if (props.component.services && this.state.accountIndexesSet !== true) {
            return this.setAccountIndexes(props);
        }
        return null;
    }

    componentDidMount() {
        const { 
            accountChangeExtraFn,
            component, 
            immAccounts, 
            immContract, 
            setAllAccountsToInactive, 
            accountId, 
            localState, 
            actions: { requestInterveners, requestIntervenersSpecial, updateCardDetails } 
        } = this.props;
        const nextProps = {
            component,
            immAccounts,
            immContract
        };
        !component.services && this.setStateAccountIndexes(nextProps);

        const allAccountsInactive = hasAllAccountsInactive(
            immAccounts.get('byOrder'),
            immAccounts.get('byId')
        );
        if( allAccountsInactive ) {
            setAllAccountsToInactive();
        }
        if (immContract.get('name_contract') === 'depositrenewal' && accountId && !immContract.get('interveners').size) {
            const { card_details } = localState;
            const immAccountsById = immAccounts.get('byId');
            const immAccount = immAccountsById.get(accountId);
            const hasAccountPreselected = card_details.find(
                detail => detail.id === 'hasAccountPreselected',
                );
                hasAccountPreselected && (hasAccountPreselected.value = true);
                const balanceAccount = card_details.find(x => x.id === 'balance_account');    
                if (balanceAccount) {
                    balanceAccount.value = immAccount.getIn(['balances', 'availableBalance', 'amount']);
                }

            card_details.find(x => x.id === component.target).value = accountId;
            card_details.find(x => x.id === component.target).description = `${immAccount.get(
                'alias'
                )} ${getLastNChars(immAccount.get('iban'))}`;
            if (component.isIntervenerAvailable && !component.intervenersSpecial) {
                requestInterveners(accountId, accountChangeExtraFn);
            } else if (component.isIntervenerAvailable && component.intervenersSpecial) {
                requestIntervenersSpecial(immAccount, accountChangeExtraFn);
            }
            updateCardDetails(card_details); 
        }
    }
        setStateAccountIndexes(props) {
            return this.setState(this.setAccountIndexes(props));
        }

    getUpgradeableToPayrollAccounts(accountsIndexes, immAccountsById) {
        const { onlyUpgradeableToPayroll } = this.props;

        if (onlyUpgradeableToPayroll) {
            accountsIndexes = accountsIndexes.filter(accountId => {
                const immAccount = immAccountsById.get(accountId);

                if (
                    immAccount &&
                    isUpgradeableToPayrollAccount(
                        immAccount.get('newProduct'),
                        immAccount.get('accountType')
                    )
                ) {
                    return accountId;
                }
            });
        }

        return accountsIndexes;
    }

    setAccountIndexes(nextProps) {
        const {
            currencyAllowed,
            setAllAccountsToInactive,
        } = this.props;
        const {
            component: {
                onlyOwner,
                onlyHolder
            },
            immAccounts
        } = nextProps;
        const data = {
            currencyAllowed,
            onlyOwner,
            onlyHolder
        };
        const immAccountsById = immAccounts.get('byId');
        let accountsIndexes;

        if (immAccountsById) {
            accountsIndexes = filterValidAccounts(immAccountsById, immAccounts, data);
            accountsIndexes = this.getUpgradeableToPayrollAccounts(accountsIndexes, immAccountsById);

            if(hasAllAccountsInactive(accountsIndexes, immAccounts.get('byId'))) {
                setAllAccountsToInactive();
            } else {
                this.autoSelectAccountIfJustOne(accountsIndexes) && this.setSingleAccount(accountsIndexes);
            }
        }

        accountsIndexes = accountsIndexes.toJS ? accountsIndexes.toJS() : accountsIndexes;
        let newState = { accountsIndexes: accountsIndexes };
        if (accountsIndexes !== undefined) {
            newState.accountIndexesSet = true;
        }
        return newState;
    }

    setSingleAccount(accountsIndexes) {
        const singleAccount = accountsIndexes.get(0);
        this.handleFromAccountChange(singleAccount);
    }

    autoSelectAccountIfJustOne(accountsIndexes) {
        return accountsIndexes.size === 1;
    }

    buildMaxAmountLabelDropdownAccounts(amount) {
        return (
            <div className="ok-slider__slider-box__info">
                <p>Importe disponible(máximo)</p>
                <p>
                    {amount} €
                </p>
            </div>
        );
    }

    //TODO: Restriction -- in the wizard only can be one account dropdown
    handleFromAccountChange(accountId) {
        const {
            doTagging,
            localState,
            component,
            immAccounts,
            immContract,
            accountChangeExtraFn,
            actions: { requestInterveners, requestIntervenersSpecial, updateCardDetails },
            customCategoryEvent
        } = this.props;
        const { card_details } = localState;
        const immAccount = immAccounts.getIn(['byId', accountId]);
        const currentAccount = card_details.find(x => x.id === component.target);
        const currentAccountValue = currentAccount ? currentAccount.value : null;

        if (accountId && currentAccountValue !== accountId) {
            const balanceAccount = card_details.find(x => x.id === 'balance_account');

            if (balanceAccount) {
                balanceAccount.value = immAccount.getIn(['balances', 'availableBalance', 'amount']);
            }

            card_details.find(x => x.id === component.target).value = accountId;
            card_details.find(x => x.id === component.target).description = `${immAccount.get(
                'alias'
            )} ${getLastNChars(immAccount.get('iban'))}`;

            if (component.isIntervenerAvailable && !component.intervenersSpecial) {
                requestInterveners(accountId, accountChangeExtraFn);
            } else if (component.isIntervenerAvailable && component.intervenersSpecial) {
                requestIntervenersSpecial(immAccount, accountChangeExtraFn);
            }
            formValidationHelper.validateComponent(
                card_details,
                component,
                immContract.get('steps'),
                immContract.get('visibleStep')
            );
            updateCardDetails(card_details);
            doTagging && recordLink(customCategoryEvent || window.utag_last_name, ACCOUNT_CHOICE_ACTION_EVENT, SELECTION_ACTION_EVENT);
    
        }
    }

    // move this to utilities
    mutateCardDetails(cardDetails, component, immAccount) {
        return cardDetails.map(item => {
            let tempItem = item;

            if (tempItem.get('id') === component.target) {
                tempItem = tempItem.withMutations(map => {
                    map.set('value', immAccount.get('accountId'));
                    map.set(
                        'description',
                        `${immAccount.get('alias')} ${getLastNChars(immAccount.get('iban'))}`
                    );
                });
            }

            return tempItem;
        });
    }

    render() {
        const {
            actions,
            accountId,
            component,
            contractBuilder,
            immAccounts,
            immContract,
            intervenersHeader,
            isInactiveAccountsEnabled,
            showIntervenersOnlyInCard,
            flagBasedFeatures,
            showSavingsAccountsMessage,
            showDisclaimer,
            customCategoryEvent
        } = this.props;
        const dropdownAccountLabel = contractBuilder[component.label]
            ? contractBuilder[component.label](immContract.get('card_details'))
            : component.label;
        const { accountsIndexes } = this.state;
        const cardDetails = immContract.get('card_details');
        const cta_seleccionada = cardDetails ? cardDetails.find(x => x.get('id') === component.target) : null;
        const maxAmountLabel = component.isMaxAmountLabelAvailable ? this.buildMaxAmountLabelDropdownAccounts(component.maxAmountValue) : '';
        let immAccountsById = immAccounts ? immAccounts.get('byId') : null;
        const isFetching = immAccounts ? immAccounts.get('isFetching') : false;
        const intervenersIsFetching = immContract.get('intervenersIsFetching');
        const error = formValidationHelper.getErrorMessage(cardDetails, component);
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');
        let selectedAccount = cta_seleccionada ? cta_seleccionada.get('value') : null;
        let initialAccountId;
        let content;
        let enabled;
        const savingsAccounts = showSavingsAccountsMessage && Array.from(immAccounts.get('byId').values()).filter((element)=> element.get('newProduct') == SAVINGS_ACCOUNT_TYPE ? element : false);

        if (Array.isArray(accountsIndexes) && accountsIndexes.length === 1) {
            initialAccountId = selectedAccount = accountsIndexes[0];
            enabled = false;
        }

        if (accountId) {
            selectedAccount = accountId;
            enabled = false;
        }
        if (isFetching || intervenersIsFetching) {
            content = <LoadingSection />;
        } else {
            let showInterveners;
            if (immAccounts && selectedAccount && component.isIntervenerAvailable && !showIntervenersOnlyInCard) {
                if (component.juniorInterveners) {
                    const handleTypeChange = actions.changeIntervenerRelationship;
                    const handleExclude = actions.excludeIntervener;
                    const juniorPersonalData = findElementbyId(
                        cardDetails,
                        'junior_form_personal_data'
                    );
                    const juniorName = findElementbyId(juniorPersonalData, 'input-safe-name');
                    const lastName = findElementbyId(juniorPersonalData, 'input-safe-last-name');
                    const secondLastName = findElementbyId(
                        juniorPersonalData,
                        'input-safe-second-last-name'
                    );
                    const titularName = `${juniorName} ${lastName} ${secondLastName || ''}`;
                    showInterveners = (
                        <JuniorInterveners
                            juniorName={titularName}
                            immJuniorInterveners={immContract.get('interveners')}
                            onTypeChange={handleTypeChange}
                            onExclude={handleExclude}
                            immContract={immContract}
                            restoreDefaultEnabled={component.restoreDefaultIntervenersEnabled}
                            restoreDefaultInterveners={actions.restoreDefaultInterveners}
                        />
                    );
                } else {
                    const renderInterveners = contractBuilder[component.renderInterveners]
                        ? contractBuilder[component.renderInterveners](immContract)
                        : true;
                    showInterveners =
                        renderInterveners &&
                        <ContractsAccountInterveners
                            accountNumber={selectedAccount}
                            setIntervenerType={actions.setIntervenerType}
                            addIntervener={actions.addIntervener}
                            removeIntervener={actions.removeIntervener}
                            restoreDefaultInterveners={actions.restoreDefaultInterveners}
                            restoreDefaultEnabled={component.restoreDefaultIntervenersEnabled}
                            immAccounts={immAccounts}
                            immContract={immContract}
                            flagBasedFeatures={flagBasedFeatures}
                            showIntervenerControls={component.showIntervenerControls}
                            hideIntervenerLinkActions={component.hideIntervenerLinkActions}
                            intervenerOptions={component.intervenerOptions}
                            hierarchicalTypeSelection={
                                component.intervenersHierarchicalTypeSelection
                            }
                            intervenersSubHeader={component.intervenersSubHeader}
                            header={intervenersHeader}
                            customCategoryEvent={customCategoryEvent}
                        />;
                }
            }
            const renewalDisclaimer = component.renewalDisclaimer && (
                <div className="contract-dropdown-account__renewal-disclaimer">
                    <OKMessage type={'informative'}>
                        <FormattedText value="contractsView-contractsView_depositRenewalStep2AccountDisclaimer"/>
                    </OKMessage>
                </div> 
            );
            content = (
                <article>
                    <section>
                        <DropdownAccounts
                            id="drd_ContractView"
                            immAccounts={immAccountsById}
                            accountsIndexes={accountsIndexes}
                            blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                            onAccountChange={this.handleFromAccountChange}
                            currentAccountId={selectedAccount}
                            error={error.state}
                            errorMsg={error.message}
                            showAvailableBalance={true}
                            enabled={enabled}
                            initialAccountId={initialAccountId}
                            label={dropdownAccountLabel}
                            showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                            showNegativeBalanceAccounts={component.showNegativeBalanceAccounts}
                            loading={isBlockedAccountsLoading}
                            onOpen={() => {
                                recordLink(customCategoryEvent || window.utag_last_name, ACCOUNT_CHOICE_ACTION_EVENT, OPEN_ACTION_EVENT)
                            }}
                            savingsAccounts={showSavingsAccountsMessage ? savingsAccounts : undefined}
                            showDisclaimer={showDisclaimer}
                            disclaimerInformative={component.disclaimerInformative}
                        />
                        {maxAmountLabel}
                        {renewalDisclaimer}
                    </section>
                    {showInterveners}
                </article>
            );
        }
        return content;
    }
}

ContractDropdownAccount.defaultProps = {
    doTagging: true,
    showIntervenersOnlyInCard: false,
    onlyUpgradeableToPayroll: false,
    currencyAllowed: EURO_TEXT,
    showSavingsAccountsMessage: false,
    showDisclaimer: true,
    customCategoryEvent: null
};

ContractDropdownAccount.propTypes = {
    doTagging: PropTypes.bool,
    accountId: PropTypes.string,
    contractBuilder: PropTypes.object.isRequired,
    localState: PropTypes.object.isRequired,
    immContract: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    component: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    accountChangeExtraFn: PropTypes.func,
    intervenersHeader: PropTypes.string,
    showIntervenersOnlyInCard: PropTypes.bool,
    onlyUpgradeableToPayroll: PropTypes.bool,
    currencyAllowed: PropTypes.string,
    setAllAccountsToInactive: PropTypes.func,
    flagBasedFeatures: PropTypes.object,
    showSavingsAccountsMessage: PropTypes.bool,
    showDisclaimer: PropTypes.bool,
    customCategoryEvent: PropTypes.string
};

module.exports = ContractDropdownAccount;
